import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import homePageReducer from '../containers/HomePage/reducer';
import designerReducer from '../containers/NewDesigner/reducer';





const history = createBrowserHistory();



/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer() {
  const rootReducer = combineReducers({
    router: connectRouter(history),
    homePage:homePageReducer,
    designer:designerReducer,
  });

  return rootReducer;
}